import { gql } from 'graphql-tag';
export const LOGIN_USER = gql`
  mutation ($email: String!, $password: String!) {
    customerAccessTokenCreate(input: { email: $email, password: $password }) {
      customerAccessToken {
        accessToken
        expiresAt
      }
    }
  }
`;

export const SIGNUP_USER = gql`
  mutation customerCreate(
    $email: String!
    $password: String!
    $firstname: String
    $lastname: String
    $phone: String
  ) {
    customerCreate(
      input: {
        email: $email
        password: $password
        firstName: $firstname
        lastName: $lastname
        phone: $phone
      }
    ) {
      customer {
        firstName
        lastName
        email
        phone
        acceptsMarketing
      }
      customerUserErrors {
        field
        message
        code
      }
    }
  }
`;

export const SIGNOUT_USER = gql`
  mutation customerAccessTokenDelete($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
      deletedAccessToken
      deletedCustomerAccessTokenId
      userErrors {
        field
        message
      }
    }
  }
`;

export const FORGET_PASSWORD = gql`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        field
        message
        code
      }
    }
  }
`;
